import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AudioConfigParams, NavigationParams } from 'types/params';

export function useGoToPage() {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    const goToPage = useCallback(
        (pageNumber: number, options: { autoPlay: 'first' | 'last' }) => {
            const urlSearchParams = new URLSearchParams(search);

            urlSearchParams.set(NavigationParams.page, pageNumber.toString());

            // TODO - https://mixgenius.atlassian.net/browse/SP-10142
            urlSearchParams.set(AudioConfigParams.autoPlay, options.autoPlay);

            navigate({
                pathname: pathname,
                search: `?${urlSearchParams.toString()}`,
            });
        },
        [navigate, search, pathname],
    );

    return {
        goToPage,
    };
}
